import {isToFile} from './helpers';

function reloadCaptcha(imgCaptcha) {
    imgCaptcha.attr('src', `/sveden/update/captcha/captcha.php?sid=${Math.random()}`);
}

const $btnFeedbackSend = $_vikon('#feedback_send');
if ($btnFeedbackSend.length) {
    $_vikon(document).on('click', '#feedback_send', () => {
        const $feedbackStatus = $_vikon('#feedback_status');

        if (isToFile()) {
            const imgCaptcha = $_vikon('#captcha');
            const nameField = $_vikon('[name="name"]');
            const emailField = $_vikon('[name="email"]');
            const subjectField = $_vikon('[name="subject"]');
            const messageField = $_vikon('[name="message"]');
            const captchaField = $_vikon('[name="captcha"]');

            imgCaptcha.on('click', () => {
                reloadCaptcha(imgCaptcha);
            });

            $_vikon(() => {
                reloadCaptcha(imgCaptcha);
            });

            const form = $_vikon('#feedback_form').serialize();
            nameField.parent().removeClass('has-error');
            emailField.parent().removeClass('has-error');
            subjectField.parent().removeClass('has-error');
            messageField.parent().removeClass('has-error');
            captchaField.parent().removeClass('has-error');
            $feedbackStatus.removeClass('bg-danger bg-success')
                .html('<ul></ul>')
                .addClass('hide');
            $_vikon.ajax({
                type: 'post',
                url: '/sveden/update/feedback.php',
                data: form,
                dataType: 'json',
                success(res) {
                    if (res.success) {
                        $feedbackStatus.html('Сообщение отправлено')
                            .addClass('bg-success')
                            .removeClass('hide');
                        nameField.val('');
                        emailField.val('');
                        subjectField.val('');
                        messageField.val('');
                        captchaField.val('');
                        reloadCaptcha(imgCaptcha);
                    } else {
                        if (res.message) {
                            $feedbackStatus.html(`Сообщение не отправлено. ${res.message}`)
                                .addClass('bg-danger')
                                .removeClass('hide');
                        }
                        res.errorID.forEach((item, i, arr) => {
                            $_vikon(`[name="${item}"]`).parent().addClass('has-error');
                        });
                        res.messages.forEach((item, i, arr) => {
                            $feedbackStatus.children('ul:first').append(`<li>${item}</li>`);
                            $feedbackStatus.addClass('bg-danger');
                            $feedbackStatus.removeClass('hide');
                        });
                        reloadCaptcha(imgCaptcha);
                        captchaField.val('');
                    }
                },
            });
        } else {
            $feedbackStatus.html('Недоступно в просмотре информации')
                .addClass('bg-danger')
                .removeClass('hide');
        }
    });
}
